import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Page,
  Link,
  Row,
  Col,
  List,
  ListItem,
  Icon,
  Block,
  f7,
  Button,
  Input,
  ListInput,
} from "framework7-react";
import { API_BASE_URL, API_AUTH } from "./../globals";

const PageOrdersDetails = ({ f7route }) => {
  const { id } = f7route.params;
  const [data, setData] = useState([]);
  const [showOrderHis, setShowOrderHis] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [couponDiscountDetails, setCouponDiscountDetails] = useState({
    overAll: 0,
    perOrder: 0,
    used: 0,
    remaining: 0,
  });
  const [total, setTotal] = useState();

  const [couponDiscount, setCouponDiscount] = useState();
  const handleChange = (e) => {
    const numericValue = e.target.value.replace(/[^\d.]/g, "");
    setCouponDiscount(numericValue);
  };
  useEffect(() => {
    localStorage.setItem("couponDiscount", JSON.stringify(couponDiscount));
  }, [couponDiscount]);

  useEffect(() => {
    console.log(id);
    localStorage.removeItem("couponDiscount");
    axios
      .get(API_BASE_URL + "orders", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cust_id: localStorage.getItem("id"),
          id: id,
        },
      })
      .then((response) => {
        setData(response.data.data);
        setTotal(response.data.data[0].grand_total);
        setCouponDiscountDetails({
          ...couponDiscountDetails,
          overAll: response.data.data[0].over_all_discount,
          perOrder: response.data.data[0].per_order_discount,
          used: response.data.data[0].used_discount,
          remaining: response.data.data[0].remaining_discount,
        });
        showOrderStatus(response.data.data[0].id);
      })
      .catch((error) => console.log(error));
  }, [id]);
  const Payment = (order_id) => {
    console.log(order_id);

    if (
      couponDiscount < couponDiscountDetails.perOrder &&
      couponDiscount > couponDiscountDetails.remaining
    ) {
      f7.toast
        .create({
          text: `Your coupon discount is limited to ${couponDiscountDetails.remaining} only.`,
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
    } else if (total - couponDiscount < 0) {
      f7.toast
        .create({
          text: "Total can not be zero...!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
    } else if (couponDiscount > couponDiscountDetails.perOrder) {
      f7.toast
        .create({
          text: "Coupon discount Higher than per order discount...!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
    } else {
      f7.views.main.router.navigate({
        name: "payment",
        params: {
          id: order_id,
        },
      });
    }
  };

  const showOrderStatus = (order_id) => {
    axios
      .get(API_BASE_URL + "orderhistory", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          order_id: order_id,
        },
      })
      .then((response) => {
        setShowOrderHis(response.data.data.reverse());
        console.log(1);
      })
      .catch((error) => console.log(error));
  };
  const renderIcon = (orderStatus) => {
    if (orderStatus === 1) {
      return (
        <img
          class="img-fluid icon step-1"
          src={require("./../images/svg/cube.svg").default}
          alt="cube"
        />
      );
    } else if (orderStatus === 2) {
      return (
        <img
          class="img-fluid icon step-3"
          src={require("./../images/svg/bike.svg").default}
          alt="bike"
        />
      );
    } else if (orderStatus === 3) {
      return (
        <img
          class="img-fluid icon step-2"
          src={require("./../images/svg/manage-payment.svg").default}
          alt="3d-cube"
        />
      );
    } else if (orderStatus === 4) {
      return (
        <img
          class="img-fluid icon step-4"
          src={require("./../images/svg/done.svg").default}
          alt="done"
        />
      );
      // } else if (orderStatus === 5) {
      //   return <img class="img-fluid icon step-1 bg-danger" src={require('./../images/svg/empty-cart.svg').default} alt="done"/>;
    } else {
      return null; // Render a default icon or nothing if no matching status
    }
  };
  return (
    <Page className="bg-white">
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Order Details</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>
          {data.map((item) => (
            <div>
              <section className="profile-form mt-3">
                <div className="custom-container p-0">
                  <div class="title">
                    <h5 className="fw-bold dark-text dark-text">
                      <span className="light-text">Order ID : </span>{" "}
                      {item.invoice_id}
                    </h5>
                    <a href="#" className="text-muted text-1">
                      {item.bid_start_date ? item.bid_start_date : ""}
                    </a>
                  </div>
                  <div className="apply-coupon mt-3">
                    <h5>
                      Status:{" "}
                      {item.order_status_text == "Unpaid" ? (
                        <span className="text-danger">Unpaid</span>
                      ) : (
                        <span className="text-success">Paid</span>
                      )}
                    </h5>
                  </div>
                  <table className="table 1table-borderless mt-2 text-2">
                    <tbody>
                      <tr>
                        <td width={"40%"}>Event Name: </td>
                        <td className="text-capitalize">
                          <b>{item.event_name}</b>
                        </td>
                      </tr>
                      <tr>
                        <td width={"40%"}>Event Date & Time: </td>
                        <td>{item.event_date}</td>
                      </tr>
                      <tr>
                        <td>Event Size: </td>
                        <td>
                          Adults - <strong>{item.event_adult_size}</strong>
                          {item.event_kids_size !== null ? (
                            <span>
                              , Kids - <strong>{item.event_kids_size}</strong>
                            </span>
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Food Need By Time: </td>
                        <td>{item.event_time}</td>
                      </tr>
                      <tr>
                        <td>Event Address: </td>
                        {item.delivery_type !== "Pick up" ? (
                          <td>
                            {item.add_lin_1}, {item.city}, {item.state},{" "}
                            {item.zip_code}
                          </td>
                        ) : (
                          <td></td>
                        )}
                      </tr>
                      <tr>
                        <td>Deliver Type: </td>
                        <td>{item.delivery_type}</td>
                      </tr>
                      <tr>
                        <td>Event Notes: </td>
                        <td>{item.event_note}</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* <h3 className="fw-bold dark-text mb-2">Restaurant Information</h3> */}
                  {/* <div className="vertical-product-box">
                <div className="vertical-box-img p-2" style={{width: '15%'}}>
                  <img alt="" slot="media" src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg" width="40" className="rounded-circle" />
                </div>
                <div className="vertical-box-details">
                  <div className="vertical-box-head">
                    <div className="restaurant">
                      <h5 className="dark-text">Ben &amp; Floren</h5>
                    </div>
                    <h6 className="food-items mb-2" style={{overflow: 'visible'}}><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> 8642 Yule Street, Arvada CO 80007</h6>                    
                  </div>              
                </div>
              </div> */}
                </div>
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Menu Items</h3>
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody>
                      {item.item.map((items, index) => (
                        <tr className="align-middle" key={index}>
                          <td width={"10%"} className="text-center">
                            {index + 1}.{" "}
                          </td>
                          <td>
                            <h5 className="dark-text fw-bold mb-1">
                              {items.menu_name}
                            </h5>
                            size : {items.menu_size_name} ({items.size})<br />
                            Tray : {items.qty}
                            <br /> Price : $
                            {parseFloat(items.total_amount).toFixed(2)}
                            <br /> Note : {items.note}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text mb-1">
                    Restaurant Information
                  </h3>
                  <h5>{item.rest_name}</h5>
                  {/* <table className='table table-striped table-sm text-2 mt-2'>
                <tbody>
                  {item.rest_data.map((restaurant, index) => (
                    <tr>
                        <td width={'10%'} className='text-center'>{index + 1}. </td>
                        <td><h5 className="dark-text fw-bold mb-1">{restaurant.rest_name}</h5><span>{restaurant.add_lin_1}, {restaurant.city}</span></td>                
                      </tr>              
                  ))}
                </tbody>
              </table>       */}
                </div>
                {/* <div className="custom-containe p-0">
              {item.order_status == 0 ?(
                <Button className="btn theme-btn w-100" onClick={() => Payment(item.id)} large type="submit">Pay </Button>
              ) :''}
            </div> */}
              </section>
              <section>
                <div class="custom-container p-0">
                  <div class="title">
                    {/* <h5 class="dark-text"><span class="light-text">Order ID : </span>{item.order_id}</h5> */}
                    <h3 className="fw-bold dark-text">Order Status</h3>
                  </div>
                  <table className="table table-sm mt-2 text-2">
                    <tbody>
                      {showOrderHis.length > 0 ? (
                        showOrderHis.map((items, index) => (
                          <tr>
                            <td>{items.time}</td>
                            <td>{items.order_status}</td>
                            <td>{items.message}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3}>
                            <h6>No order history</h6>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>

              <section className="bill-details section-lg-b-space">
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Payment Details </h3>
                  <table className="table table-sm mt-2 text-2">
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td className="text-end">
                          $ {parseFloat(item.sub_total).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Discount{" "}
                          <span className="text-success fw-bold text-2">
                            {item.discount > 0 && item.promo > 0
                              ? `(${item.discount_note})`
                              : ""}
                          </span>
                        </td>
                        <td className="text-end">
                          {item.discount > 0
                            ? `$ ${parseFloat(item.discount).toFixed(2)}`
                            : `$ ${0}`}
                        </td>
                      </tr>
                      <tr>
                        <td>Coupon Discount </td>
                        <td className="text-end">
                          {/* <Input
                            type="text"
                            // required
                            small
                            validate
                            pattern="[0-9\s]{1,4}"
                            errorMessage="Please enter correct value."
                            className="form-control"
                            placeholder="Discount "
                            name="discount"
                            style={{width:"200px",marginLeft:"920px"}}
                            // onChange={discountAddItem}
                            // value={formData.discount}
                          /> */}
                          $
                          {item.order_status_text == "Unpaid" ? (
                            <input
                              style={{
                                width: "200px",
                                border: "1px solid lightgrey",
                                padding: "0px 10px",
                              }}
                              placeholder=""
                              value={couponDiscount}
                              onChange={handleChange}
                            ></input>
                          ) : (
                            parseFloat(item.coupon_discount).toFixed(2)
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Sales Tax({item.tax !== 0 ? item.sales_tax : 0}%)
                        </td>
                        <td className="text-end fw-bold">
                          ${parseFloat(item.tax).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td className="text-end fw-bold">
                          ${" "}
                          {couponDiscount
                            ? parseFloat(
                                item.grand_total - couponDiscount
                              ).toFixed(2)
                            : parseFloat(item.grand_total).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="custom-containe p-0">
                  {item.order_status == 0 ? (
                    <Button
                      className="btn theme-btn w-100"
                      onClick={() => Payment(item.id)}
                      large
                      type="submit"
                    >
                      Pay
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </section>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default PageOrdersDetails;
